import React, { memo, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface ICommercialTextProps {
  text: string;
  maxLength?: number;
}

export const TextDisplay = styled.div`
  color: ${(props) => props.theme.textColorDarken};
  font-size: 12px;
  white-space: break-spaces;
`;

export const ButtonToggle = styled.button`
  background: none;
  border: none;
  color: ${(props) => props.theme.primaryColor};
  cursor: pointer;
  font-size: 12px;
  padding-left: 4px;
`;

const Text = (props: ICommercialTextProps) => {
  const { t } = useTranslation();
  const { text, maxLength = 250 } = props;
  const [showFullText, setShowFullText] = useState(false);
  if (!text) return null;
  const isLong = text.length > maxLength;
  const displayText =
    showFullText || !isLong ? text : text.slice(0, maxLength) + "...";
  const mappedText = displayText.split("\r\n").join("</br>");

  return (
    <TextDisplay data-test="commercial-description">
      <span dangerouslySetInnerHTML={{ __html: mappedText }} />
      {isLong && (
        <ButtonToggle
          type="button"
          onClick={() => setShowFullText((v) => !v)}
          data-test="toggle-full-text"
        >
          {showFullText
            ? t("instabook.common.see_less")
            : t("instabook.common.see_more")}
        </ButtonToggle>
      )}
    </TextDisplay>
  );
};

export const CommercialText = memo(Text);
